import { fmtPts } from "../lib/api";

const LIVE = ["IN_PLAY", "PAUSED"];

const PickLine = ({ p }) => {
  const r = p.result;
  const color = !r ? "text-slate-500" : r.correct ? "text-emerald-400" : "text-red-400";
  return (
    <li className="grid grid-cols-[1fr_auto_auto] items-center gap-2 py-1 text-xs" data-testid={`slip-pick-${p.match_id}`}>
      <span className="truncate text-slate-300">
        {p.home} - {p.away}
        {p.score_home != null && (
          <span className={`ml-1.5 font-mono ${LIVE.includes(p.status) ? "text-red-400" : "text-slate-500"}`}>
            {p.score_home}-{p.score_away}{LIVE.includes(p.status) ? " LIVE" : ""}
          </span>
        )}
      </span>
      <span className={`font-display text-sm font-bold ${p.pick_type === "fissa" ? "text-emerald-400" : "text-blue-400"}`}>
        {p.pick}{p.exact_home != null && <span className="text-violet-400 ml-1">({p.exact_home}-{p.exact_away})</span>}
      </span>
      <span className={`font-mono w-9 text-right ${color}`}>{r ? `+${fmtPts(r.points)}` : "—"}</span>
    </li>
  );
};

export const Slip = ({ title, slip, testId }) => (
  <div className="card-surface px-4 py-3" data-testid={testId}>
    <div className="flex items-center justify-between gap-2 mb-1 pb-1 border-b border-[#26334D]">
      <h4 className="font-display text-base font-bold uppercase truncate">{title}</h4>
      <span className="shrink-0 text-xs font-mono uppercase text-slate-400" data-testid={`${testId}-points`}>
        Punti <span className="font-display text-lg font-black text-emerald-400 ml-1">{slip.points != null ? fmtPts(slip.points) : "—"}</span>
        {slip.bonus > 0 && <span className="ml-1 text-amber-400">+{slip.bonus}</span>}
      </span>
    </div>
    {slip.picks.length ? (
      <ul className="divide-y divide-[#26334D]/60">{slip.picks.map((p) => <PickLine key={p.match_id} p={p} />)}</ul>
    ) : (
      <p className="text-xs text-slate-500 py-1">Nessun pronostico consegnato.</p>
    )}
  </div>
);
